import { Button, Modal, Typography } from 'antd';
import { useT } from '../../../locales';

export interface RoleUnsavedChangesModalProps {
  open: boolean;
  onKeepEditing: () => void;
  onDiscard: () => void;
}

export function RoleUnsavedChangesModal({
  open,
  onKeepEditing,
  onDiscard,
}: RoleUnsavedChangesModalProps) {
  const t = useT();

  return (
    <Modal
      open={open}
      centered
      title={t('pages.roles.unsavedChangesTitle')}
      onCancel={onKeepEditing}
      destroyOnHidden
      footer={[
        <Button key="keep-editing" onClick={onKeepEditing}>
          {t('pages.roles.unsavedChangesCancel')}
        </Button>,
        <Button key="discard" type="primary" danger onClick={onDiscard}>
          {t('pages.roles.unsavedChangesConfirm')}
        </Button>,
      ]}
    >
      <Typography.Paragraph style={{ marginBottom: 0 }}>
        {t('pages.roles.unsavedChangesDescription')}
      </Typography.Paragraph>
    </Modal>
  );
}
